import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { SubmitButton } from "../../components/Input";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const AiCallingPromptForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("authToken");

  const [title, setTitle] = useState("");
  const [promptText, setPromptText] = useState("");
  const [subscribers, setSubscribers] = useState(0);
  const [leadComments, setLeadComments] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) fetchPrompt();
  }, [id]);

  const fetchPrompt = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}settings/ai-prompts/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = response.data.data;
      setTitle(data.title || "");
      setPromptText(data.prompt_text || "");
      setSubscribers(Number(data.subscribers) === 1 ? 1 : 0);
      setLeadComments(Number(data.lead_comments) === 1 ? 1 : 0);
    } catch (error) {
      console.error("Error fetching prompt:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const payload = {
      title,
      prompt_text: promptText,
      subscribers,
      lead_comments: leadComments,
    };
    try {
      const url = id
        ? `${API_URL}settings/ai-prompts/${id}`
        : `${API_URL}settings/ai-prompts`;

      const response = await axios({
        method: id ? "put" : "post",
        url,
        data: payload,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data) {
        showToast.success(response.data.message || (id ? "Prompt updated successfully" : "Prompt created successfully"));
        navigate("/Settings/AiCallingPrompts");
      }
    } catch (error) {
      console.error("Error saving prompt:", error);
      showToast.error("There was an error saving the prompt");
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">
                {id ? "Edit " : "Add "} AI Prompt
              </span>
            </div>
            <div className="panel-body">
              <div className="row">

                {/* Title */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      placeholder="Enter prompt title (e.g. Sales Call Prompt)"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* Prompt Text */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Prompt Text</label>
                    <textarea
                      name="prompt_text"
                      className="form-control"
                      placeholder="Enter the AI prompt text here..."
                      value={promptText}
                      onChange={(e) => setPromptText(e.target.value)}
                      rows="10"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="checkbox">
                    <input
                      id="ai-prompt-subscribers"
                      type="checkbox"
                      checked={subscribers === 1}
                      onChange={(e) => setSubscribers(e.target.checked ? 1 : 0)}
                    />
                    <label htmlFor="ai-prompt-subscribers">Subscribers</label>
                  </div>
                  <div className="checkbox">
                    <input
                      id="ai-prompt-lead-comments"
                      type="checkbox"
                      checked={leadComments === 1}
                      onChange={(e) => setLeadComments(e.target.checked ? 1 : 0)}
                    />
                    <label htmlFor="ai-prompt-lead-comments">Lead Comments</label>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="col-md-12">
                  <SubmitButton
                    pageBack="/Settings/AiCallingPrompts"
                    handleSubmit={handleSubmit}
                  />
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AiCallingPromptForm;
